function WidgetItemCheckList({ id, name, completed, checkHandler }) {
    return (
        <div key={'check_' + id} className="checkbox-wrapper mt-5" >
            <label htmlFor={'check_' + id} className="item" style={{ display: 'flex', marginTop: '10px' }}>
                <input type="checkbox" id={'check_' + id} className="hidden" defaultChecked={completed}
                    onClick={(e) => checkHandler(id, e.target.checked)}
                />
                <label htmlFor={'check_' + id} className="cbx">
                    <svg width="14px" height="12px" viewBox="0 0 14 12">
                        <polyline points="1 7.6 5 11 13 1"></polyline>
                    </svg>
                </label>
                <label htmlFor={'check_' + id} className="cbx-lbl">{name}</label>
            </label>
        </div>
    )
}

export default WidgetItemCheckList;